import type {
  ConversationItemApi,
  SuggestionQuery,
  IntroQuery,
  AskQuery,
  AgentItemApi,
  SuggestionItemApi,
  IntroItemApi,
  PatientConversationQuery,
} from "@/Modules/Agent/Models/Api";

import { get2, post2, remove2 } from "./utils/FunctionalTherapyApi";

export async function getConversations(): Promise<ConversationItemApi[]> {
  return get2<void, ConversationItemApi[]>(`/v1.0/rag/conversations`);
}

export async function getConversation(customerUuid: string): Promise<AgentItemApi[]> {
  return get2<void, AgentItemApi[]>(`/v1.0/rag/conversations/${customerUuid}`);
}

export async function getUserConversations(customerUuid: string): Promise<ConversationItemApi[]> {
  return get2<PatientConversationQuery, ConversationItemApi[]>("/v1.0/rag/conversations", {
    customer_uuid: customerUuid,
  });
}

export async function deleteConversation(customerUuid: string): Promise<AgentItemApi[]> {
  return remove2<void, AgentItemApi[]>(`/v1.0/rag/conversations/${customerUuid}`);
}

export async function getIntro(customerUuid: string): Promise<IntroItemApi> {
  return get2<IntroQuery, IntroItemApi>("/v1.0/rag/intro", {
    customer_uuid: customerUuid,
  });
}

export async function getSuggestions(customerUuid: string): Promise<SuggestionItemApi[]> {
  return get2<SuggestionQuery, SuggestionItemApi[]>("/v1.0/rag/buttons", {
    customer_uuid: customerUuid,
  });
}

export async function postAsk(customerUuid: string, question: string): Promise<AgentItemApi> {
  return post2<AskQuery, AgentItemApi>(`/v1.0/rag/conversations/${customerUuid}`, {
    question: question,
  });
}
